import React from "react";
import GenericPullAndPushToolView from "../GenericPullAndPushToolView";
import OrcaSecurityShiftLeftCredentialsForm from "./OrcaSecurityShiftLeftCredentialsForm";
import OrcaSecurityShiftLeftConfigListing from "./OrcaSecurityShiftLeftConfigListing";

export default function OrcaSecurityShiftLeftPullAndPushView(props) {
  return (
    <GenericPullAndPushToolView
      {...props}
      PullCredentialForm={OrcaSecurityShiftLeftCredentialsForm}
      PullConfigListingView={OrcaSecurityShiftLeftConfigListing}
    />
  );
}
